import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UniversityService {

  constructor(private http: HttpClient) {
  }

  fetchUniversities(ids: [], selections: [], allDB: string) {
    const selections_str = selections.map(s => `${s['id']}_${s['mode']}`);
    return this.http.get(`/api/datasource/my-university/?ids=${ids.join(',')}&selections=${selections_str}&all_db=${allDB}`);
  }


  addErrorMessage(formData: FormData) {
    return this.http.post('/api/datasource/error-messages/', formData);
  }

  changeProfileUniversity(formData: FormData) {
    return this.http.post('/api/core/profile/', formData);
  }

}
